module.exports = __webpack_public_path__ + "media/categories/292-d99c4dab.svg";